import { combineReducers } from 'redux-immutable';
import { immutableExperimentReducer as abisko } from '@svt/abtest/redux-immutable';

import autocomplete from './autocomplete';
import continueWatching from './continueWatching';
import filter from './filter';
// import guidePage from './guidePage';
// import location from './location';
import menu from './menu';
import navigation from './navigation';
import network from './network';
import onboarding from './onboarding';
import selectedTab from './selectedTab';
import settings from './settings';
import shareButtons from './shareButtons';
import statistics from './statistics';
import utils from './utils';
import videoPage from './videoPage';
import videoPlayer from './videoPlayer';

export const reducer = combineReducers({
    abisko,
    autocomplete,
    continueWatching,
    filter,
    // guidePage,
    // location,
    menu,
    navigation,
    network,
    onboarding,
    selectedTab,
    settings,
    shareButtons,
    statistics,
    utils,
    videoPage,
    videoPlayer,
});
